import { cn } from "~/lib/utils";
import { usePillSelectorContext } from "./context";

interface OptionProps {
  value: string;
  children: React.ReactNode;
}

export function Option({ value, children }: OptionProps) {
  const { value: selectedValue, multi, onToggle, disabled, onKeyDown } = usePillSelectorContext();

  const isSelected = multi ? Array.isArray(selectedValue) && selectedValue.includes(value) : selectedValue === value;

  const handleClick = () => onToggle(value);

  return (
    <button
      type="button"
      role={multi ? undefined : "radio"}
      aria-checked={multi ? undefined : isSelected}
      aria-pressed={multi ? isSelected : undefined}
      disabled={disabled}
      tabIndex={multi ? 0 : isSelected || selectedValue === null ? 0 : -1}
      data-value={value}
      onClick={handleClick}
      onKeyDown={(e) => onKeyDown(e, value)}
      className={cn(
        "inline-flex min-w-9 items-center justify-center gap-1 rounded-full px-2.5 py-1.5 text-xs leading-none transition-colors",
        "border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        {
          "border-border text-muted-foreground hover:border-foreground/30 hover:text-foreground": !isSelected,
          "border-primary ring-1 ring-primary text-foreground": isSelected,
          "opacity-50 cursor-not-allowed": disabled,
        },
      )}
    >
      {children}
    </button>
  );
}
